import api from '@/sui/api/password'
import password from '@/sui/tools/password'

// actions
const actions = {
  reset ({ commit }, request) {
    const pwd = password(request.email, request.password)
    return api.resetPassword(
      request.prefix,
      request.id,
      request.email,
      pwd
    ).then((response) => {
      return response
    })
  },
  init ({ commit }, request) {
    return api.initPassword(
      request.prefix,
      request.name,
      request.firstName,
      request.email,
      request.source
    ).then((response) => {
      return response
    })
  }
}

export default {
  namespaced: true,
  actions
}
